import type { PropsWithChildren } from 'react';
import React from 'react';
import type { MediaProps } from './Media';
import Media from './Media';

interface Props {
    poster?: string;
    alt: string;
}

const SideVideo = (props: PropsWithChildren<Omit<MediaProps<Props>, 'component'>>) => (
    <Media
        component="video"
        autoPlay
        muted
        loop
        playsInline
        {...props}
    />
);

export default SideVideo;
